import classNames from "classnames";
import styles from "./Input.module.scss";
import { Input as AntInput, InputProps as AntInputProps } from "antd";
import Copy from "../Copy/Copy";
import { ReactChild, useEffect, useRef, useState } from "react";
import { PasswordProps } from "antd/es/input";
import { CloseCircleFilled } from "@ant-design/icons";

// type InputProps = {
//   label?: React.ReactNode;
//   wrapClassName?: string;
//   colored?: boolean;
//   copyButton?: boolean;
//   outlined?: boolean;
//   outlinedOnFocus?: boolean;
//   regExp?: RegExp;
// } & (
//     ({
//       inputType?: "text";
//     } & AntInputProps) | ({
//       inputType: "password";
//     } & PasswordProps)
//   )

interface BaseInputProps {
  label?: React.ReactNode;
  wrapClassName?: string;
  colored?: boolean;
  copyButton?: boolean;
  outlined?: boolean;
  outlinedOnFocus?: boolean;
  regExp?: RegExp;
  error?: ReactChild;
}
type TextInput = BaseInputProps & AntInputProps & { inputType?: "text" };
type PasswordInput = BaseInputProps & PasswordProps & { inputType: "password" };
type InputProps = TextInput | PasswordInput;

function Input({
  inputType,
  copyButton,
  outlined,
  outlinedOnFocus,
  wrapClassName,
  regExp,
  ...props
}: InputProps) {

  const [value, setValue] = useState(props.value ?? props.defaultValue);
  const clear = useRef<HTMLSpanElement>(null);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      setValue(props.value);
    }
  }, [props.value]);

  const params = {
    ...props,
    value: value,
    size: props.size,
    className: classNames(props.className, {
      [styles.colored]: props.colored,
      [styles.outlined]: outlined,
      [styles.outlinedOnFocus]: outlinedOnFocus,
      [styles.noValue]: !value && props.allowClear && !props.disabled && !props.readOnly,
    }),
    allowClear: props.allowClear && { clearIcon: <span ref={clear}></span> },
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      if (regExp && !regExp.test(e.target.value)) return;
      setValue(e.target.value);
      if (props.onChange) {
        return props.onChange(e);
      }
    },
    prefix: props.allowClear && !props.disabled && !props.readOnly ? <div className={styles.prefix}>
      {props.prefix}
      <CloseCircleFilled
        className={classNames(styles.clear, { [styles.hide]: !value })}
        onClick={() => clear.current?.click()}
      />
    </div> : props.prefix,
    suffix: copyButton && <Copy size={16} text={`${value ?? ""}`} /> || props.suffix,
  };

  const InputComponent = inputType === "password"
    ? AntInput.Password
    : AntInput;

  return (
    <label className={classNames(styles.input, {
      [styles.large]: props.size === "large"
    }, wrapClassName)}>
      {props.label}
      <InputComponent {...params} />
      {props.error}
    </label>
  );
}

export { Input };
